import { render, staticRenderFns } from "./ProgramEdit.vue?vue&type=template&id=4d6822f4"
import script from "./ProgramEdit.vue?vue&type=script&lang=js"
export * from "./ProgramEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports